import React, { useState } from "react";
import useEligibilityDetails from "hooks/eligibility/useEligibilityDetails";
import useInterval from "helperHooks/useInterval";
import { EligibilityDetailsState } from "store/eligibility/state";
import useEligibilityMetaData from "./hooks/auth/useEligibilityMetaData";
import useLoanStatus from "hooks/auth/useLoanStatus";

const LOAN_POLL_BASE_TIMER = 5000;
const LOAN_POLL_VARIABLE = 1000;
const LOAN_POLL_MAX = 120000;

/**
 * This component is used only to contain states and functions that need to be run but leave no visual impact
 * @returns 
 */
const UtilityComponent = () => {
  const [runPoll, setRunPoll] = useState(true);
  // const [first,setFirst] = useState(true);
  const [pollTimerVariable, setPollTimerVariable] = useState(0);
  const {
    getEligibilityMetaData,
    eligibilityMetaData: { eligibilityId }
  } = useEligibilityMetaData();
  const {
    fetchLoanCalculation,
    eligibilityState: { loanDetails, eligibilityDetails }
  } = useEligibilityDetails();

  const { showAwaitingInPrincipleMessage } = useLoanStatus();
  
  const timer = pollTimerVariable + LOAN_POLL_BASE_TIMER;
  const shouldPollRun = () => runPoll || showAwaitingInPrincipleMessage
  const checkFetchLoanCalculation = () => {
    if (eligibilityId && loanDetails.calculating) {
      if (!loanDetails.loading && !loanDetails.calculated) {
        fetchLoanCalculation(eligibilityId);
      }
      else if (loanDetails.calculated) {
        if (!eligibilityDetails || eligibilityDetails === {} as EligibilityDetailsState)
          getEligibilityMetaData(null as any);
        runPoll && setRunPoll(false);
      }
      setPollTimerVariable(LOAN_POLL_VARIABLE);
    }
    else{
      runPoll && setRunPoll(false);
    }
    setPollTimerVariable(timer >= LOAN_POLL_MAX ? 0 : pollTimerVariable + LOAN_POLL_VARIABLE);
  };
  useInterval(async () => checkFetchLoanCalculation(), shouldPollRun() ? timer : null as any);
  // if(first && eligibilityId){
  //   fetchLoanCalculation(eligibilityId, true);
  //   setFirst(false);
  // }
  return (
    <React.Fragment></React.Fragment>
  )
}

export default UtilityComponent;